/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteModelCatalogEntryRequest = {
  id: string;
};

/** @internal */
export const DeleteModelCatalogEntryRequest$inboundSchema: z.ZodType<
  DeleteModelCatalogEntryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type DeleteModelCatalogEntryRequest$Outbound = {
  id: string;
};

/** @internal */
export const DeleteModelCatalogEntryRequest$outboundSchema: z.ZodType<
  DeleteModelCatalogEntryRequest$Outbound,
  z.ZodTypeDef,
  DeleteModelCatalogEntryRequest
> = z.object({
  id: z.string(),
});

export function deleteModelCatalogEntryRequestToJSON(
  deleteModelCatalogEntryRequest: DeleteModelCatalogEntryRequest,
): string {
  return JSON.stringify(
    DeleteModelCatalogEntryRequest$outboundSchema.parse(
      deleteModelCatalogEntryRequest,
    ),
  );
}
export function deleteModelCatalogEntryRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteModelCatalogEntryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteModelCatalogEntryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteModelCatalogEntryRequest' from JSON`,
  );
}
